import { Activity } from '~/types/bootcamp'
import { selectCurrentActivityType } from '~/bootcamp/slices/bootcamp-activity.slice'
import { useAppSelector } from '~/redux/hooks'
import { GemType } from '~/components/Rock/types'

export default function useGetGemType(activities: Activity[]): GemType {
  const activityType = useAppSelector(selectCurrentActivityType)
  const activity = activities.find((elem) => elem.type === activityType)
  return activity?.gemType || 'red'
}
